import {
  seoSegmentationListingPage,
  seoSegmentationListingPage_seoArticlesList_SEOArticlesListSuccess_seoArticlesList_articles as SEOArticle,
} from '@/__generated__/seoSegmentationListingPage';

/**
 * @JSDOC
 * This function extracts the articles data from the SEOArticlesList object.
 * It checks if the SEOArticlesList is of type 'SEOArticlesListSuccess' and returns the articles.
 * If the type is not 'SEOArticlesListSuccess', it returns an empty array.
 * @param {seoSegmentationListingPage['seoArticlesList']} seoArticlesList - The SEOArticlesList object.
 * @returns {seoSegmentationListingPage['seoArticlesList']['articles']} - The articles data or an empty array.
 * @example
 * const articles = getArticlesList(seoArticlesList);
 * // articles will be of type seoSegmentationListingPage['seoArticlesList']['articles']
 * // If seoArticlesList is of type 'SEOArticlesListSuccess', it will contain the articles.
 * // If not, it will be an empty array.
 */

export const getArticlesList = (
  seoArticlesList: seoSegmentationListingPage['seoArticlesList']
): SEOArticle[] => {
  if (seoArticlesList.__typename === 'SEOArticlesListSuccess') {
    return seoArticlesList.seoArticlesList?.articles ?? [];
  }
  return [];
};
